import { render, staticRenderFns } from "./headTotal.vue?vue&type=template&id=1a5c1d3b&scoped=true"
import script from "./headTotal.vue?vue&type=script&lang=js"
export * from "./headTotal.vue?vue&type=script&lang=js"
import style0 from "./headTotal.vue?vue&type=style&index=0&id=1a5c1d3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c1d3b",
  null
  
)

export default component.exports